import React, { useEffect, useState } from 'react'
import { fetchNewsArticles } from '../api/newsArticleApi'
import NewsArticleCards from '../components/UI/NewsArticleCards'

const NewsArticles = () => {
  const [articles, setArticles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    async function loadArticles() {
      setLoading(true)
      setError('')
      try {
        const data = await fetchNewsArticles()
        if (!cancelled) {
          setArticles(data.filter((article) => Number(article.status) === 1))
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load news articles')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadArticles()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <>
      <section className='space-top'>
        <div className="container">
          <div className="about-title">
            <h2 className='text-lora font-semibold '>
              Myth Busters – News & Articles
            </h2>
            <p>Read insightful articles that separate myths from reality in the world of astrology and numerology.</p>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          {loading && (
            <p className="text-center py-5">Loading articles...</p>
          )}
          {error && !loading && (
            <p className="text-center py-5 text-danger">{error}</p>
          )}
          {!loading && !error && articles.length === 0 && (
            <p className="text-center py-5">No articles available right now.</p>
          )}
          {!loading && !error && articles.length > 0 && (
            <div className="row shop-product-grid g-3">
              {articles.map((article) => (
                <div className="col-xl-3 col-lg-3 col-md-6 col-12" key={article.article_id}>
                  <NewsArticleCards article={article} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  )
}

export default NewsArticles
